﻿import {
  arrayOf,
  bool,
  exact,
  number,
  object,
  oneOfType,
  string,
} from "prop-types";
import { formFieldPropertyType } from "./formFieldPropertyType";
import { translationType } from "./translationType";

const formFieldBaseType = {
  canDelete: bool,
  property: formFieldPropertyType,
  values: arrayOf(oneOfType([string, object])),
  category: exact({
    label: translationType.isRequired,
    order: number,
    showDownloadAll: bool,
    isRequired: bool,
  }),
};

formFieldBaseType.children = arrayOf(exact(formFieldBaseType));

/** @deprecated use TypeScript interface or type instead */
export const formFieldType = exact(formFieldBaseType);
